<template>
  <div class="container-full">    
    <ChangerLocale/>
    <nav class="navigation-bar">
      <ul class="container-menu-top">
        <li>
          <a href="https://www.facebook.com/profile.php?id=100092391947342&mibextid=LQQJ4d"
            target="_blank">
            <img
              class="image-icon"
              src="@/assets/layout/icons/icon-facebook-24.png"
              alt="facebook"
            />
          </a>
        </li>        
        <li>
          <a
            href="https://www.instagram.com/quality_care2023?igsh=aGd3M3Fvem53bW1s"
            target="_blank"
            ><img
              class="image-icon"
              src="@/assets/layout/icons/icon-instagram-24.png"
              alt=""
          /></a>
        </li>        
      </ul>
    </nav>
    <div class="show-login">
      <LoginContainer :showLabel="false" />
    </div>
  </div>
</template>

<script>
import LoginContainer from "./container_login.vue";
import ChangerLocale from "../changer_locale.vue";
export default {
  components: {
    LoginContainer,
    ChangerLocale,
  },
  name: "topHeader",
};
</script>

<style scoped>
.container-full {
  background-color: #f3f8fc;
  height: 35px;
  width: 100%;
  display: flex;
  padding-right: 19vw;
  justify-content: space-between;
  padding-left: 5vw;
}
.container-menu-top {
  display: flex;
  user-select: none;
}
.container-menu-top li {
  display: flex;
  list-style: none;
  background-color: #2b86d9;
  height: 35px;
  width: 50px;
  align-items: center;
  justify-content: center;
  transition: 0.5s all;
  padding: 2.5px;
  cursor: pointer;
}
.container-menu-top li:hover {
  opacity: 0.8;
}

.image-icon {
  height: 20px;
}
.show-login {
  display: none;
}
@media screen and (max-width: 960px) {
  .container-full {
    padding-right: 0;
    justify-content: space-between;
  }
  .show-login {
    display: flex;
  }
}
</style>
